/**
 * Created by JasonChou on 16/5/3.
 */

/**
 * 微信支付域名以?结尾
 */

export default {
  fixAndroidPaySafeUrlBug() {
    let change;

    if (!location.search) {

      if (location.hash) {
        change = location.hash;
      }

      change = '?1' + change;//会覆盖location.hash
    }

    if (change)
      location.replace(change);
  }

};



// WEBPACK FOOTER //
// ./src/services/wxBugFixer.js